<i18n src="@/i18n/components/Notifications.json"></i18n>
<i18n src="@/i18n/notifications/index.json"></i18n>
<template>
	<div class="pointer-events-auto w-full max-w-sm rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
		<div class="flex relative">
			<!-- Content !-->
			<div class="flex-1 p-4">
				<div class="flex items-center" @click.stop="handleClick">
					<!-- Icon !-->
					<div class="flex-shrink-0 px-1">
						<i class="fal text-2xl" :class="notificationIconClass"></i>
					</div>
					<!-- Title !-->
					<div class="ml-3 w-0 flex-1 pt-0.5">
						<p class="text-sm font-medium text-gray-900">{{ title }}</p>
						<div v-if="hasMessage" class="mt-1 text-sm text-gray-500">
							<p v-html="message"/>
						</div>
					</div>
					<!-- Close !-->
					<template v-if="!hasActions">
						<div class="w-4 h-4 p-2.5 absolute top-1 right-1 flex justify-center items-center bg-white rounded-full">
							<button type="button"
									class="text-gray-400 hover:text-red-500 focus:text-red-500 text-xs"
									@click.stop="handleClose">
								<i class="fa fa-times"></i>
							</button>
						</div>
					</template>
					<!-- / Close !-->
				</div>
			</div>
			<!-- Actions !-->
			<template v-if="hasActions">
				<div class="flex border-l border-gray-200" :class="{
						'divide-y divide-gray-200 flex-col' : notification.actions.length > 1
					}">
					<!-- One Action !-->
					<template v-if="notification.actions.length === 1">
						<button
							type="button"
							class="flex w-full items-center justify-center rounded-none rounded-r-lg border border-transparent p-4 text-sm font-medium text-turquoise hover:text-turquoise focus:outline-none focus:ring-2 focus:ring-turquoise"
							@click.stop="handleAction(notification.actions[0])">
							{{ $t("notification.actions." + notification.actions[0].label) }}
						</button>
					</template>
					<!-- / One Action !-->
					<!-- Multi Actions !-->
					<template v-else>
						<div class="flex h-0 flex-1">
							<!-- Action !-->
							<button
								type="button"
								class="flex w-full items-center justify-center rounded-none rounded-tr-lg border border-transparent px-4 py-3 text-sm font-medium text-turquoise hover:text-turquoise focus:z-10 focus:outline-none focus:ring-2 focus:ring-turquoise"
								@click.stop="handleAction(notification.actions[0])">
								{{ $t("notification.actions." + notification.actions[0].label) }}
							</button>
						</div>
						<div class="flex h-0 flex-1">
							<!-- Action !-->
							<button
								type="button"
								class="flex w-full items-center justify-center rounded-none rounded-br-lg border border-transparent px-4 py-3 text-sm font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-turquoise"
								@click.stop="handleAction(notification.actions[1])">
								{{ $t("notification.actions." + notification.actions[1].label) }}
							</button>
						</div>
					</template>
					<!-- / Multi Actions !-->
				</div>
			</template>
			<!-- / Actions !-->
			<!-- Loading !-->
			<Loading v-if="isActionLoading" use-spinner spinner-color="text-turquoise"/>
		</div>
	</div>
</template>

<script>
import Loading from "@/components/Loading.vue"
import HandleCloseMixin from "./mixins/handle_close.js"
import HandleActionMixin from "./mixins/handle_action.js"
import {dispatch} from "vuex-pathify";

export default {
	name: "SimpleNotification",
	mixins: [
		HandleCloseMixin,
		HandleActionMixin
	],
	props: {
		notification: {
			type: Object,
			required: true
		}
	},
	components: {Loading},
	computed: {
		/**
		 * Calculate notification type icon class
		 * @returns {VueI18n.TranslateResult}
		 */
		title() {
			return this.$t(`notification.${this.notification.data.code}.title`, this.notification.data.params)
		},
		/**
		 * Calculate notification message
		 * @returns {VueI18n.TranslateResult}
		 */
		message() {
			return this.$t(`notification.${this.notification.data.code}.message`, this.notification.data.params)
		},
		/**
		 * Check if notification has a message
		 * @returns {boolean}
		 */
		hasMessage() {
			return this.message !== `notification.${this.notification.data.code}.message`
		},
		/**
		 * Calculate notification type icon class
		 * @returns {*}
		 */
		notificationIconClass() {
			return {
				'info': 'fa-info-circle text-gray-500',
				'success': 'fa-check-circle text-green-500',
				'warning': 'fa-warning text-yellow-500',
				'error': 'fa-times-circle text-red-500',
			}[this.notification.notification_status]
		}
	},
	methods: {
		/**
		 * Handle click on notification
		 */
		handleClick(){
			if(this.notification.actions?.length === 1) {
				this.handleAction(this.notification.actions[0])

				dispatch('Notifications/readNotification', { id: this.notification.id }, {root: true})
			}

			this.close()
		},
		// .. handleAction
		// .. handleClose
		// .. delayClose
	}
}
</script>
